import { render } from "./FormAddMenu.vue?vue&type=template&id=7ebfaf1a&scoped=true"
import script from "./FormAddMenu.vue?vue&type=script&lang=js"
export * from "./FormAddMenu.vue?vue&type=script&lang=js"

import "./FormAddMenu.vue?vue&type=style&index=0&id=7ebfaf1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebfaf1a"]])

export default __exports__